import { PrimaryButton } from 'src/shared/components/button/Button';
import useAppNavigation from 'src/shared/hooks/useAppNavigation';
import { ArrowRight as ArrowForward } from 'lucide-react';
import usePortfolioSiteExplorerAnalytics from '../../hooks/usePortfolioSiteExplorerAnalytics';

const ViewButton = ({
    site,
    buttonText,
    locationForTracking,
}: {
    site: {
        hasEdna: boolean;
        hasHabitatInsights: boolean;
        id: string;
    };
    buttonText?: string;
    locationForTracking?: string;
}) => {
    const navigate = useAppNavigation();
    const { trackViewButtonClick } = usePortfolioSiteExplorerAnalytics();
    let navigateHandler = null;

    if (site.hasEdna || site.hasHabitatInsights) {
        navigateHandler = () => {
            trackViewButtonClick(site.id, site.hasEdna, site.hasHabitatInsights, locationForTracking);
            navigate.toSiteSummary({ projectId: site.id });
        };
    }
    return (
        <PrimaryButton
            key={site.id}
            className='flex items-center gap-2 p-2'
            onClick={navigateHandler || undefined}
            disabled={!navigateHandler}
        >
            {buttonText || 'View'}
            <ArrowForward />
        </PrimaryButton>
    );
};

export default ViewButton;
